import { Component, Output, EventEmitter, OnInit  } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Observable } from 'rxjs';
import { GameState, Q2Results, Q3Results, Q4Results, QuarterType } from '../../interfaces/game.interface';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-taerra-page',
  templateUrl: './taerra-page.component.html',
  styleUrls: ['./taerra-page.component.scss']
})
export class TaerraPageComponent implements OnInit {
  @Output() callFileClick = new EventEmitter<void>();
  @Output() districtInfoClick = new EventEmitter<string>();
  @Output() districtClick = new EventEmitter<number>();
  @Output() navigateToKpi = new EventEmitter<void>();
  @Output() navigateToNews = new EventEmitter<void>();
  @Output() aamClick = new EventEmitter<void>();
  @Output() quarterOneEndTriggered = new EventEmitter<{
    success: boolean,
    correctSelections: number,
    incorrectIds: string[]
  }>();
  @Output() quarterTwoEndTriggered = new EventEmitter<Q2Results>();
  @Output() quarterThreeEndTriggered = new EventEmitter<Q3Results>();
  @Output() quarterFourEndTriggered = new EventEmitter<Q4Results>();

  instructionInitial: string = "";
  instructionAdditional: string[] = [];
  quarter$!: Observable<QuarterType>;
  shopNumbers = {'University': 0, 'Retail': 0, 'Suburban': 0, 'Shopping Centre': 0, 'Industrial': 0};

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.initializeInstructions();
    this.initializeQuarter();
    setTimeout(() => this.initializeShopNumbers(), 500);
  }

  private initializeQuarter(): void {
    this.quarter$ = this.dataService.gameState$.pipe(
      filter((state): state is GameState => state !== null),
      map(state => state.game_state)
    );
  }

  private initializeInstructions() {
    this.dataService.getPageInstructionsObservable().subscribe(instructions => {
      this.instructionInitial = instructions.initial;
      this.instructionAdditional = instructions.additional;
    })
  }

  private initializeShopNumbers() {
    const state = this.dataService.getGameStateSnapshot();
    if (!state) return false;

    const shops = state.stores;
    if (!shops) return false;

    Object.values(shops).forEach(shop => {
        const district = shop.district;
        this.shopNumbers[district]++;
    });

    return true;
}

  onCallFileClick(): void {
    this.callFileClick.emit();
  }

  onDistrictInfoClick(district: string): void {
    this.districtInfoClick.emit(district);
  }

  onDistrictClick(district: number): void {
    this.districtClick.emit(district);
  }

  onNavigateToKpi(): void {
    this.navigateToKpi.emit();
  }

  onNavigateToNews(): void {
    this.navigateToNews.emit();
  }

  onAamClick(): void {
    this.aamClick.emit();
  }

  isQuarterFinished(): boolean {
    const state = this.dataService.getGameStateSnapshot();
    if (!state) return false;
    
    switch(state.game_state) {
      case 'q1': return this.dataService.isQuarterOneFinished();
      case 'q2': return this.dataService.isQuarterTwoFinished();
      case 'q3': return this.dataService.isQuarterThreeFinished();
      case 'q4': return this.dataService.isQuarterFourFinished();
      default: return false;
    }
  }

  endQuarter() {
    const state = this.dataService.getGameStateSnapshot();
    if (!state) return false;

    switch(state.game_state) {
      case 'q1': {
        this.dataService.concludeQuarterOne().then(res => {
          this.quarterOneEndTriggered.emit(res);
        }).catch(error => console.error(error));
        break;
      }
      case 'q2': {
        this.dataService.concludeQuarterTwo().then(res => {
          this.quarterTwoEndTriggered.emit(res);
        }).catch(error => console.error(error));
        break;
      }
      case 'q3': {
        this.dataService.concludeQuarterThree().then(res => {
          this.quarterThreeEndTriggered.emit(res);
        }).catch(error => console.error(error));
        break;
      }
      case 'q4': {
        this.dataService.concludeQuarterFour().then(res => {
          this.quarterFourEndTriggered.emit(res);
        }).catch(error => console.error(error));
        break;
      }
      default: return;
    }
  }
}
